<template>
    <div class="c-activity__status">
        <div
            v-if="5 === activity.status_id"
            class="font-size-base pt-1 text-secondary"
        >
            Task Skipped
        </div>
        <div
            v-else-if="3 === activity.status_id"
            class="font-size-base pt-1 text-secondary"
        >
            Task Deleted
        </div>
        <div v-else class="c-activity__complete-button">
            <div @click="toggleStatus">
                <animated-checkbox
                    class="mr-2"
                    :size="'medium'"
                    :checked="2 === activity.status_id"
                    :disabled="false"
                ></animated-checkbox>
                <label>{{ label }}</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    data() {
        return {
            activity: this.value,
        };
    },
    components: {
        AnimatedCheckbox: function() {
            return import("@/js/components/partials/animated-checkbox");
        },
    },
    watch: {
        value() {
            this.activity = this.value;
        },
    },
    computed: {
        formattedDate() {
            return this.activity.completed_at
                ? this.$moment(this.activity.completed_at).calendar()
                : "";
        },
        label() {
            return (this.activity.status_id == 2) === true
                ? "Completed " + this.formattedDate
                : "Mark as Complete";
        },
    },
    methods: {
        toggleStatus() {
            this.$emit("update", this.activity.status_id == 2 ? 1 : 2);
        },
    },
};
</script>
